import _taggedTemplateLiteral from "/var/lib/jenkins/workspace/familjecentralenpaletten.staffanstorp.se/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
import { css, jsx } from "@emotion/react";
import clsx from "clsx";
import PropTypes from "prop-types";
import * as defaultStyles from "./Icon.module.css";
import { useIconContext } from "./IconProvider";
import withComponentDefaults from "../utils/withComponentDefaults";
import { filterAttributes } from "../utils";
export default withComponentDefaults(Icon, "icon");
function Icon(_a) {
  var _b = _a,
    {
      children,
      className,
      color,
      name,
      src,
      styles = defaultStyles,
      size
    } = _b,
    restProps = __objRest(_b, ["children", "className", "color", "name", "src", "styles", "size"]);
  void 0;
  let {
    getIconSrc
  } = useIconContext();
  if (name) {
    src = getIconSrc(name);
  }
  if (!src) {
    if (true) {
      if (name) {
        console.warn("Could not find any icon by the name \"".concat(name, "\". Did you wrap your app in an <IconProvider> and pass a \"getIconSrc\" prop?"));
      } else {
        console.warn("No \"src\" or \"name\" prop provided to <Icon> component.");
      }
    }
  }
  let attributes = filterAttributes(restProps);
  return /* @__PURE__ */jsx("span", __spreadValues({
    className: clsx(styles.component, className),
    css: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        --icon-color: ", ";\n        --icon-size: ", ";\n        mask-image: url(", ");\n      "])), color, size, src)
  }, attributes));
}
Icon.propTypes = {
  children: PropTypes.oneOf([null, void 0, "", false]),
  className: PropTypes.string,
  color: PropTypes.string,
  name: PropTypes.string,
  src: PropTypes.string,
  styles: PropTypes.objectOf(PropTypes.string),
  size: PropTypes.string
};